import { Component } from '@angular/core';

import { environment } from '@env/environment';

/** Pie de página común a las apps de Enterprise Solutions (mismo formato que portalfront). */
@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.html',
  // El host es el ítem del flex del layout: sin `block mt-auto` el pie no baja al fondo en páginas cortas.
  host: { class: 'mt-auto block' }
})
export class AppFooter {
  protected readonly appVersion = environment.appVersion;
}
